import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ListHeader } from "../../../../components/admin/list/list-header";
import { ListFilter } from "../../../../components/admin/list/list-filter";
import { Paginate } from "../../../../components/paginate/paginate";
import { ListInquiry } from "./list-category/list-inquiry";
import { ListFaq } from "./list-category/list-faq";
import { ViewInquiry } from "./regist-category/view-inquiry";
import { RegistFaq } from "./regist-category/regist-faq";
import { useGetFaqListMutation } from "../../../../store/admin/adminFaqApiSlice";
import { useGetInquiryListMutation } from "../../../../store/admin/adminInquiryApiSlice";
interface ParamType {page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}
export interface PageInfo{className_1 : string, className_2 : string, title : string, totalCount : number}
export const CustomerCenter = () => {
    const location = useLocation()
    const page : any = new URLSearchParams(location.search).get('page') || 1;
    const keyword : any = new URLSearchParams(location.search).get('keyword') || '';
    const order : any = new URLSearchParams(location.search).get('order') || 'desc';
    const column : any = new URLSearchParams(location.search).get('column') || 'subject';
    const navigate = useNavigate()
    const {contentsType, contentsId} = useParams()
    const [data, setData] = useState<any>([])
    const [param, setParam] = useState<ParamType>({page : page, size : 10, keyword : keyword, sortOrder : order, sortColumn : column})
    const [getInquiryListApi] = useGetInquiryListMutation()
    const [getFaqListApi] = useGetFaqListMutation()
    const [pageInfo , setPageInfo] = useState<PageInfo>({
        className_1 :  '', 
        className_2 : '', 
        title : '', 
        totalCount : 0
    })
    const getList = async() => {
        if(contentsType === 'faq'){
            const result : any = await getFaqListApi(param)
            if(result.data.result === true){
                setData(result.data.list); setPageInfo((prev)=>({...prev, totalCount : result.data.total_cnt}))
            }
        }else{
            const result : any = await getInquiryListApi(param)
            if(result.data.result === true){
                setData(result.data.list); setPageInfo((prev)=>({...prev, totalCount : result.data.total_cnt}))
            }
        }
    }

    const handlePage = (pageNumber:number)=>{
        if(parseInt(page)!==pageNumber){
            navigate(`${location.pathname}?page=${pageNumber}&keyword=${keyword}&column=${column}&order=${order}`)
        }
    }
    useEffect(()=>{setParam((prev)=>({...prev, page : page, keyword : keyword, sortOrder : order, sortColumn : column}))},[page, keyword, order, column])
    useEffect(()=>{
        if(location.pathname === `/dotsAdmin/customerCenter/${contentsType}`){
            getList()
        }
    }, [contentsType,contentsId,param.page,param.keyword,param.sortColumn,param.sortOrder])
    useLayoutEffect(()=>{
        switch(contentsType){
            case 'inquiry' : setPageInfo((prev)=>({...prev, className_1 : 'listOfInquiry', title : 'List of Inquiry'})); break;
            case 'faq' : setPageInfo((prev)=>({...prev, className_1 : 'listOfFAQ', title : 'List of FAQ'})); break;
            default : break;
        }
    }, [contentsType])
    return(
        <>
        {!contentsId ? 
        <div className={`contentBox ${pageInfo.className_1}`}>
            <h3>Customer Center</h3>
            <ListHeader pageInfo={pageInfo} column={column}/>
            
            <table className={`table_hover ${pageInfo.className_2}`}>
                <ListFilter column={column} order={order}/>
                {contentsType === 'inquiry' ? <ListInquiry data={data}/> : ''}
                {contentsType === 'faq' ? <ListFaq data={data} getList={getList}/> : ''}
            </table>
            {contentsType === 'faq'?
            <button className="addNewBtn" onClick={()=>navigate(`${location.pathname}/regist`)}>Add New</button>
            : ''
            }

            <div className="pagerBox">
                <Paginate page={page} totalCount={pageInfo.totalCount} size={10} setPage={handlePage}/>
            </div>
        </div> 
        
        :

        <>
            {contentsType === 'inquiry' ? <ViewInquiry/> : ''}
            {contentsType === 'faq' ? <RegistFaq/> : ''}
        </>
        }
        </>
    )
}